import { lazy, Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import ErrorBoundary from 'components/elements/ErrorBoundary';
import AccountExpiringDialog from 'components/authentication/AccountExpiringDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
	accountDataSelector,
	accountExpiringDialogOpenSelector,
	setAccountExpiringDialogOpen
} from 'reducers/userAuthSlice';
import { getAircraftMakes, getAircraftModels } from 'apis/aircraft.api';
import { getBatteryMakes, getBatteryModels } from 'apis/batteries.api';
import {
	aircraftMakesSelector,
	aircraftModelsSelector,
	batteryMakesSelector,
	batteryModelsSelector
} from 'reducers/globalSlice';

const SideMenu = lazy(() => import('components/navigation/SideMenu'));

const styles = {
	withSideNav: {
		display: 'flex',
		flexDirection: 'row',
		flex: '1 1 auto',
		height: '100%',
		overflow: 'auto'
	}
};

const AccountContainer = () => {
	const dispatch = useDispatch();
	const accountExpiringDialogOpen = useSelector(accountExpiringDialogOpenSelector);
	const accountData = useSelector(accountDataSelector);
	const batteryMakes = useSelector(batteryMakesSelector);
	const batteryModels = useSelector(batteryModelsSelector);
	const aircraftMakes = useSelector(aircraftMakesSelector);
	const aircraftModels = useSelector(aircraftModelsSelector);

	const handleClose = () => {
		dispatch(setAccountExpiringDialogOpen(false));
	};
	useEffect(() => {
		const fetchAircraftMakes = async () => {
			await dispatch(getAircraftMakes());
		};
		if (aircraftMakes.length === 0) {
			fetchAircraftMakes();
		}
	}, [aircraftMakes, dispatch]);

	useEffect(() => {
		const fetchAircraftModels = async () => {
			await dispatch(getAircraftModels());
		};
		if (aircraftModels.length === 0) {
			fetchAircraftModels();
		}
	}, [aircraftModels, dispatch]);

	useEffect(() => {
		const fetchBatteryMakes = async () => {
			await dispatch(getBatteryMakes());
		};
		if (batteryMakes.length === 0) {
			fetchBatteryMakes();
		}
	}, [batteryMakes, dispatch]);

	useEffect(() => {
		const fetchBatteryModels = async () => {
			await dispatch(getBatteryModels());
		};
		if (batteryModels.length === 0) {
			fetchBatteryModels();
		}
	}, [batteryModels, dispatch]);

	return (
		<Box className='App'>
			{accountData && !accountExpiringDialogOpen && (
				<>
					<ErrorBoundary>
						<Suspense fallback={null}>
							<SideMenu />
						</Suspense>
					</ErrorBoundary>
					<ErrorBoundary>
						<Box component='main' sx={styles.withSideNav}>
							<Outlet />
						</Box>
					</ErrorBoundary>
				</>
			)}
			<AccountExpiringDialog open={accountExpiringDialogOpen} handleClose={handleClose} />
		</Box>
	);
};

export default AccountContainer;
